import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';
import { CTAButton } from 'components/atoms/Button/Button';
import '../downloadRcm.scss';
import { DownloadIcon } from 'components/atoms/Icons/iconList';
import { goToCustomUrl } from 'controls/utils';

export function ReleaseNotes({ data }) {
  return (
    <div>
      <div className='releaseNotesContainer'>
        <div
          className='releaseNotesContainer_title'
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(data.latestReleaseTitle),
          }}
        />

        <div
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(data.latestReleaseDate),
          }}
        />

        <CTAButton
          ctaText={data.ctaText}
          Icon={DownloadIcon}
          iconColor='#39A9F7'
          className='releaseNotesCta'
          onClick={() => goToCustomUrl(data.ctaUrl)}
        />
      </div>
    </div>
  );
}

ReleaseNotes.propTypes = {
  data: PropTypes.shape({
    latestReleaseTitle: PropTypes.string.isRequired,
    latestReleaseDate: PropTypes.string.isRequired,
    ctaText: PropTypes.string.isRequired,
    ctaUrl: PropTypes.string.isRequired,
  }).isRequired,
};
